"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZONE_STATUS_LIST = exports.ZONE_SIZE = exports.ZONE_MODULE_NAME = void 0;
var ZONE_MODULE_NAME = 'ZONE_MODULE';
exports.ZONE_MODULE_NAME = ZONE_MODULE_NAME;
var ZONE_SIZE = 650;
exports.ZONE_SIZE = ZONE_SIZE;
var ZONE_STATUS_LIST = {
  NOT_PLAYED: 'NOT_PLAYED',
  PLAYED: 'PLAYED',
  SELECTED: 'CURRENT'
};
exports.ZONE_STATUS_LIST = ZONE_STATUS_LIST;